import * as z from 'zod';

import { dayZod, interestsSchema, monthsZod } from '@/_containers';
import { emailSchema, numericStringFormSchema, urlSchema } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { contactQuerySchema } from './contact-query-schema';

export const contactFormSchema = contactQuerySchema
  .omit({
    first_name: true,
    last_name: true,
    remote_worker: true,
    interests: true,
    pet_names: true,
    children_names: true,
    spouse_name: true,
    username: true,
    title: true,
    email: true,
    linked_in_url: true,
    twitter_handle: true,
    status: true,
    birth_day: true,
    birth_month: true,
    registration_date: true,
    work_anniversary: true,
    wedding_anniversary: true,
    agreements: true,
  })
  .extend({
    first_name: z.string().refine((value) => value.trim().length !== 0, {
      error: 'String must contain at least 1 character',
    }),
    last_name: z.string(),

    interests: interestsSchema(),
    email: emailSchema(),
    status: statusFormSchema,
    title: z.string(),
    linked_in_url: urlSchema(),
    twitter_handle: urlSchema(),

    spouse_name: z.string(),
    children_names: z.string(),
    pet_names: z.string(),

    remote_worker: z.enum(['0', '1']),

    birth_day: dayZod,
    birth_month: monthsZod,

    work_anniversary: z.string().optional(),
    wedding_anniversary: z.string().optional(),

    freshdesk: numericStringFormSchema(),
  });

export type ContactFormSchema = z.infer<typeof contactFormSchema>;
